export const tiposLigacao = [
  { value: '0', label: 'Monofásica' },
  { value: '1', label: 'Bifásica' },
  { value: '2', label: 'Trifásica' },
  { value: '3', label: 'Grupo A' },
];
